import { ACTIVITY_LEVEL_VALUE } from '@/features/filter/activity-level';

import { useI18n } from '@experience/i18n';
import ru from '../i18n/ru.json';

export const getActivityLevelFilterItems = () => {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  return {
    MINIMUM: {
      label: t('minimum'),
      description: t('minimumDescription'),
      value: ACTIVITY_LEVEL_VALUE.MINIMUM,
    },
    EASY: {
      label: t('easy'),
      description: t('easyDescription'),
      value: ACTIVITY_LEVEL_VALUE.EASY,
    },
    MEDIUM: {
      label: t('medium'),
      description: t('mediumDescription'),
      value: ACTIVITY_LEVEL_VALUE.MEDIUM,
    },
    HARD: {
      label: t('hard'),
      description: t('hardDescription'),
      value: ACTIVITY_LEVEL_VALUE.HARD,
    },
  };
};
